import * as d3 from 'd3'

export default {
  methods: {

    draw_Values(selection) {
      let cht = this.chart
      let tube = this.tube
      let base = this.base
      let title = this.title
      let col = this.columns

      let tubeChart = selection
      .append('g')
      .attr('transform', `translate(.5, .5)`)

      // Progress
      let data = col.find(f=> f.code == 'PROG')
      tubeChart
      .append('text')
      .attr('transform', `translate(${tube.tickness / 2},${tube.height + base.textY + data.tSize*0.26})`)
      .style('font-size', data.tSize).style('font-weight', 400).attr('fill', data.tColor)
      .attr('text-anchor', 'middle')
      .text(`${this.rawData.PROG}%`)

      // Lines
      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 5).attr('y1', tube.height)
      .attr('x2', tube.tickness + 18).attr('y2', tube.height)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.5)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 5).attr('y1', cht.scale(this.rawData.PROG))
      .attr('x2', tube.tickness + 18).attr('y2', cht.scale(this.rawData.PROG))
      .style('stroke', '#bcbcbc').style('stroke-width', 0.5)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 5).attr('y1', 0)
      .attr('x2', tube.tickness + 18).attr('y2', 0)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.5)

      tubeChart
      .append('line')
      .attr('x1', tube.tickness + 15).attr('y1', 0)
      .attr('x2', tube.tickness + 15).attr('y2', tube.height)
      .style('stroke', '#bcbcbc').style('stroke-width', 0.5)

      
      // TOTAL
      data = col.find(f=> f.code == 'TOTAL')
      tubeChart
      .append('text')
      .attr('id', `TOTAL_${this.localId}`)
      .attr('transform', `translate(${tube.tickness/2},${cht.scale(100)-tube.tickness/3 + data.tSize*0.26})`)
      .style('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'middle')
      .text(this.rawData.TOTAL)
      .call(this.event_Link, data)

      if(title.visible == 'Y') {
        tubeChart
        .append('text')
        .attr('transform', `translate(${(tube.tickness/2) + (this.getNode( `#TOTAL_${this.localId}`, 'width')/2) + 10},${cht.scale(100)-tube.tickness/3 + title.tSize*0.26})`)
        .style('font-size', title.tSize).attr('fill', title.tColor)
        .text(data.name)
      }


      // ACTUAL
      data = col.find(f=> f.code == 'ACTUAL')
      tubeChart
      .append('text')
      .attr('id', `ACTUAL_${this.localId}`)
      .attr('transform', `translate(${tube.tickness + 21},${cht.scale(this.rawData.PROG/2) + data.tSize*0.26})`)
      .style('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'start')
      .text(this.rawData.ACTUAL)
      .call(this.event_Link, data)

      if(title.visible == 'Y') {
        tubeChart
        .append('text')
        .attr('transform', `translate(${tube.tickness + 26 + this.getNode( `#ACTUAL_${this.localId}`, 'width')},${cht.scale(this.rawData.PROG/2) + title.tSize*0.26})`)
        .style('font-size', title.tSize).attr('fill', title.tColor)
        .attr('text-anchor', 'start')
        .text(data.name)
      }


      // REMAIN
      data = col.find(f=> f.code == 'REMAIN')
      tubeChart
      .append('text')
      .attr('id', `REMAIN_${this.localId}`)
      .attr('transform', `translate(${tube.tickness + 21},${cht.scale(this.rawData.PROG + (100-this.rawData.PROG)/2) + data.tSize*0.26})`)
      .style('font-size', data.tSize).attr('fill', data.tColor)
      .attr('text-anchor', 'start')
      .text(this.rawData.REMAIN)
      .call(this.event_Link, data)

      if(title.visible == 'Y') {
        tubeChart
        .append('text')
        .attr('transform', `translate(${tube.tickness + 26 + this.getNode( `#REMAIN_${this.localId}`, 'width')},${cht.scale(this.rawData.PROG + (100-this.rawData.PROG)/2) + title.tSize*0.26})`)
        .style('font-size', title.tSize).attr('fill', title.tColor)
        .attr('text-anchor', 'start')
        .text(data.name)
      }


    },




    
  }
}